module.exports = __webpack_public_path__ + "img/works_nikkei_telecon_2.280e7063.png";